import { render, staticRenderFns } from "./CCMCarePlanAdd.vue?vue&type=template&id=28d16ed1"
import script from "./CCMCarePlanAdd.vue?vue&type=script&lang=js"
export * from "./CCMCarePlanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports